/**
 * Employee Web — `/me/requests/new` submit form route (EW-10, EW-12).
 *
 * Validates `?type=` via TanStack Router `validateSearch` so a deep link can
 * pre-select the type. Inline types (leave / overtime / other)
 * render their sub-form here; the dedicated-route types (document / loan /
 * expense / travel) are redirected to their own routes by NewRequestRoute.
 */
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { NewRequestRoute } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/requests/new")({
  staticData: { breadcrumb: { labelKey: "requests:page.new_request" } },
  validateSearch: z.object({
    type: z
      .enum(["leave", "overtime", "document", "other", "loan", "expense", "travel"])
      .optional(),
  }),
  component: NewRequestRoute,
});
